import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import styles from "./RecipePop.module.scss";
import toast from "react-hot-toast";
import {
  useAddRecipeMutation,
  useUpdateRecipeMutation,
} from "../../../store/services/recipeService";

import Dropzone from "../../Dropzone/Dropzone";
import { MdDelete } from "react-icons/md";

const RecipePop = ({ title, modalOpen, setModalOpen, edit }) => {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      title: "",
      // ingredients: edit?.ingredients || [],
      // instructions: edit?.instructions || "",
      imageName: "",
      //cleanedIngredients: edit?.cleanedIngredients || "",
      //status: edit?.status || "active",
    },
  });
console.log("watch", watch());
  useEffect(() => {
    if (modalOpen) {
      if (edit) {
        reset({
          title: edit?.title || "",
          imageName: edit?.imageName || "",
        });
      } else {
        reset({
          title: "",
          imageName: "",
        });
      }
    }
  }, [edit, reset, modalOpen]);

  // const { fields, append, remove } = useFieldArray({
  //   control,
  //   name: "ingredients",
  // });
  //

  const [addRecipe, { isLoading: isAdding }] = useAddRecipeMutation();
  const [updateRecipe, { isLoading: isUpdating }] = useUpdateRecipeMutation();

  const onSubmit = async (data) => {
    try {
      if (edit) {
        await updateRecipe({ recipeId: edit._id, updatedData: data });
      } else {
        await addRecipe(data).unwrap();
      }
      setModalOpen(false);
      toast.success(`Recipe ${edit ? "updated" : "added"} successfully`);
    } catch (error) {
      console.error("Failed to save the recipe:", error);
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      show={modalOpen}
      className={`${styles.RecipePop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col lg="12" md="12" className="my-2">
                {/* Title Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Title
                  </label>
                  <input
                    type="text"
                    placeholder="Enter title"
                    className="form-control"
                    // {...register("title", { required: "Please enter title" })}
                    {...register("title", {
                      required: "Please enter title",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "Title cannot start with a space";
                        }
                        // if (/[^a-zA-Z0-9\s]/.test(value)) {
                        //   return "Title cannot include special characters or emojis";
                        // }
                        return true;
                      },
                    })}
                  />
                  {errors.title && (
                    <span className="text-danger">{errors.title.message}</span>
                  )}
                </div>
              </Col>

              {/* <Col lg="12" md="12" className="my-2">
              
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Ingredients
                  </label>
                  {fields.map((field, index) => (
                    <div key={field.id} className="d-flex mb-2">
                      <input
                        type="text"
                        placeholder={`Ingredient ${index + 1}`}
                        className="form-control me-2"
                        {...register(`ingredients.${index}`, {
                         // required: "Ingredient is required",
                        })}
                      />
                      <Button variant="danger" onClick={() => remove(index)}>
                       <MdDelete />
                      </Button>
                    </div>
                  ))}
                  <Button
                    //variant="secondary"
                    onClick={() => append("")}
                    type="button"
                    style={{backgroundColor: "#3e0799" , marginLeft: "5px"}}
                  >
                    Add Ingredient
                  </Button>
                  {errors.ingredients && (
                    <span className="text-danger">
                      {errors.ingredients.message}
                    </span>
                  )}
                </div>
              </Col> */}

              {/* <Col lg="12" md="12" className="my-2">
               
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Instruction
                  </label>
                  <textarea
                    rows={6}
                    style={{ resize: "vertical", minHeight: "90px" }}
                    placeholder="Enter instruction"
                    className="form-control"
                    // {...register("instructions", {
                    //   required: "Please enter instructions",
                    // })}
                    {...register("instructions", {
                      // required: "Please enter instruction",
                      // validate: (value) => {
                      //   if (/^\s/.test(value)) {
                      //     return "Instruction cannot start with a space";
                      //   }
                      //   if (/[^a-zA-Z0-9\s]/.test(value)) {
                      //     return "Instruction cannot include special characters or emojis";
                      //   }
                      //   return true;
                      // },
                    })}
                  />
                  {errors.instructions && (
                    <span className="text-danger">
                      {errors.instructions.message}
                    </span>
                  )}
                </div>
              </Col> */}

              <Col lg="12" md="12" className="my-2">
                {/* Description Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Image
                  </label>

                  {/* <Controller
                    name="imageName"
                    control={control}
                    rules={{ required: "Please enter image" }}
                    render={({ field }) => (
                      <Dropzone
                        field="imageName"
                        setFieldValue={setValue}
                       // value={field.value}
                        value={field.value ? `https://kalofy-live.s3.us-east-1.amazonaws.com/${field.value}` : ""}
                        error={errors}
                      />
                    )}
                  /> */}

                  <Controller
                    name="imageName"
                    control={control}
                    rules={{ required: "Please enter an image" }}
                    render={({ field }) => {
                      let imageUrl = "";
                      // Use field.value if it's not empty (user uploaded new image or form was reset),
                      // otherwise fall back to edit?.imageName for display when editing
                      const imageValue = (field.value && field.value.trim() !== "") 
                        ? field.value 
                        : (edit?.imageName || "");
                      
                      if (imageValue) {
                        // Check if it's already a full URL
                        if (imageValue.startsWith("http://") || imageValue.startsWith("https://")) {
                          imageUrl = imageValue;
                        } else if (edit?.baseUrl) {
                          // Use baseUrl from edit object if available
                          imageUrl = `${edit.baseUrl}${imageValue}`;
                        } else {
                          // Fallback to S3 URL
                          imageUrl = `https://kalofy-live.s3.us-east-1.amazonaws.com/${imageValue}`;
                        }
                      }

                      return (
                        <Dropzone
                          field="imageName"
                          setFieldValue={setValue}
                          value={imageUrl}
                          error={errors}
                        />
                      );
                    }}
                  />

                  {errors.imageName && (
                    <span className="text-danger">
                      {errors.imageName.message}
                    </span>
                  )}
                </div>
              </Col>

              {/* <Col lg="12" md="12" className="my-2">
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Cleaned Ingredients
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("cleanedIngredients", {
                      setValueAs: (value) =>
                        value
                          .map((item) => item.trim())
                          .join(", "),
                    })}
                  />
                </div>
              </Col> */}

              {/* <Col lg="12" md="12" className="my-2">
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Status
                  </label>
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="active"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Active
                      </label>
                    </li>
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="inactive"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Inactive
                      </label>
                    </li>
                  </ul>
                  {errors.status && (
                    <span className="text-danger">{errors.status.message}</span>
                  )}
                </div>
              </Col> */}
            </Row>

            {/* Submit & Cancel Buttons */}
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center justify-content-center gap-10">
                <Button
                  className="d-flex align-items-center justify-content-center commonBtn"
                  type="submit"
                  disabled={isAdding || isUpdating}
                >
                  Submit
                </Button>
                <Button
                  className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                  type="button"
                  onClick={() => setModalOpen(false)}
                >
                  Cancel
                </Button>
              </div>
            </Col>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RecipePop;
